// AB3 Academy — общие имена CustomEvent для wire-up Banner ↔ SandboxSessionContext.
// Выделено в отдельный модуль чтобы Banner и Context не зависели друг от друга.

/**
 * Эмитится PracticeSandboxBanner при клике «Проверить».
 * SandboxSessionProvider слушает глобально, делает finishPractice + navigate.
 */
export const SANDBOX_VERIFY_EVENT = 'ab3-sandbox-verify-requested';
